
































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {EditFamilyTypeEnum} from '@/modules/neovehicle/models/enums';
import {FamilyModelEdit, FamilyGroupManagement, FamilyManagement} from '@/modules/neovehicle/models/family';
import MarketControl from '@/modules/neovehicle/components/market-controls.component.vue';
import { IMarket } from '@/modules/neovehicle/models';
import { Market } from '@/modules/neovehicle/models/market';
import { SocialClass } from '@/modules/neovehicle/models/socialClass';

@Component({
  components: { MarketControl },
})
export default class extends Vue {
  @Prop({required: true})
  public familyEdit: FamilyModelEdit;

  @Prop({required: true})
  public type: EditFamilyTypeEnum;

  @Prop({required: true})
  public families: FamilyManagement[];

  @Prop({required: true})
  public groups: FamilyGroupManagement[];

  @Prop({required: true})
  public socialClasses: SocialClass[];

  @Prop({required: true})
  public isLatam: boolean;

  @Prop({required: true})
  public isOpen: boolean;

  public editFamilyType = EditFamilyTypeEnum;
  public familyEditInterval: FamilyModelEdit | null = null;

  public isOpenInternal: boolean = false;

  public market: IMarket = new Market('0', '');

  private name = {
    [EditFamilyTypeEnum.Family]: 'Família',
    [EditFamilyTypeEnum.FamilyVersion]: 'Família Versão',
    [EditFamilyTypeEnum.FamilyGroup]: 'Família Grupo',
  };

  public get getLabelName() {
    return this.name[this.type];
  }

  public get isFamilyEdit() {
    return this.type === EditFamilyTypeEnum.Family;
  }

  public get isFamilyVersionEdit() {
    return this.type === EditFamilyTypeEnum.FamilyVersion;
  }

  public get isFamilyGroupEdit() {
    return this.type === EditFamilyTypeEnum.FamilyGroup;
  }

  @Watch('market', { deep: true })
  public watchMarket() {
    this.familyEditInterval!.marketValueReference = this.market.getDateISO();
    this.familyEditInterval!.marketValue = this.market.getMoneyNumber();
  }

  public created() {
    const date = !this.familyEdit.marketValueReference
      ? ''
      : this.familyEdit.marketValueReference;

    const money = !this.familyEdit.marketValue
      ? '0,00'
      : String(parseFloat(String(this.familyEdit.marketValue)).toFixed(2));

    this.market = new Market(money, date);
  }

  public mounted() {
    this.familyEditInterval = this.familyEdit;
    this.isOpenInternal = this.isOpen;
  }

  public handleCancel() {
    this.$emit('cancel');
  }

  public handleSave() {
    if (this.isFamilyVersionEdit) {
      const [ok, msg] = this.market.validate();

      if (!ok) {
        alert(msg);
        return;
      }
    }

    this.$emit('save', this.familyEditInterval);
  }

  public handleChangeFamily(idFamily: number) {
    const family = this.families.filter((x: FamilyManagement) => x.idFamily === idFamily)[0];
    this.familyEditInterval!.idFamilyGroupNew = family.idFamilyGroup;
  }

  public handleModelsMove() {
    this.$emit('move-models', this.familyEditInterval);
  }
}
